const awsConfigProd = {
	aws_cognito_region: "ca-central-1",
	aws_user_pools_id: "ca-central-1_WsHMKi7rl",
	aws_user_pools_web_client_id: "7rcn09v75ggohagkcir05f7ahv",
};
const awsConfigDev = {
	Auth: {
		// identityPoolId: "ca-central-1:6e1330ee-3595-4ad2-ace4-8baa585f6a7c",
		region: "ca-central-1",
		// mandatorySignIn: true,
		userPoolId: "ca-central-1_W8jMJIZUg",
		userPoolWebClientId: "6iaivijriqom6hqjmr34dk9sfd",
	},
	oauth: {
		domain: "policecerts-uat.auth.ca-central-1.amazoncognito.com",
		scope: ["email", "openid", "aws.cognito.signin.user.admin"],
		redirectSignIn: "https://uat.policecerts.com",
		redirectSignOut: "https://uat.policecerts.com",
		responseType: "code", // or 'token', note that REFRESH token will only be generated when the responseType is code
	},
};
const stripeConfigDev = {
	publicKey: "pk_test_51GJlx9Ax69KuAXazk8SYtWvX0JH09iBEDZZWi3GAP7ow2jfqg0j5F3g2vInDZprjobR7xjpTXjlzklYFrQFDiMeV00rHSzaVak",
};
const stripeConfigProd = {
	publicKey: "pk_live_51GJlx9Ax69KuAXazHD08R6BPropcysd7pHhBUOHQUURoIS07L1tkGTOEpR8hBBroqYw38TchIdXP29XLkKMG4MLx00p17ZrAIl",
};

const devConfig = {
	apiUrl: "https://qa.policecerts.com/api/v1.0",
	appUrl: "https://uat.policecerts.com",
	environment: "non-prod",
	awsConfig: awsConfigDev,
	stripeConfig: stripeConfigDev,
};
const prodConfig = {
	appUrl: "https://apply.policecerts.com",
	apiUrl: "https://api.policecerts.com/api/v1.0",
	environment: "prod",
	awsConfig: awsConfigProd,
	stripeConfig: stripeConfigProd,
};
const config = process.env.REACT_APP_environment === "PROD" ? prodConfig : devConfig;
console.log(process.env.REACT_APP_environment);
export { config };
